export const dataURLtoFile = (dataurl: any, filename: any) => {
  if (typeof dataurl !== "string" || !dataurl.startsWith("data:")) {
    throw new Error("dataurl should be a valid Data URL string");
  }

  const arr: any = dataurl?.split(",");
  const mime: any = arr[0]?.match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n: any = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
};
